import { useTranslation } from "react-i18next";

import { FilterButton, IOption } from "@digital-services/ui";
import { usePaginationContext } from "@ds-cps/ui";

import { resourceTypeOptions } from "@resource/models";

import { useResourcesContext } from "../context/useResourcesContext";

export const ResourceTypeFilter = () => {
  const { resourceTypeFilter, setResourceTypeFilter } = useResourcesContext();
  const { pageIndex, setPageIndex } = usePaginationContext();

  const { t } = useTranslation(undefined, {
    keyPrefix: "resources"
  });

  return (
    <FilterButton
      data-testid="filter-by-resource-type"
      singleFilter={true}
      options={resourceTypeOptions}
      selected={resourceTypeFilter ? [resourceTypeFilter] : []}
      onSelect={(options: IOption[]) => {
        if (options?.length) {
          setResourceTypeFilter(options[0]);
        } else {
          setResourceTypeFilter(null);
        }

        // This is to reset pagination when filtering by device type or state happens
        if (pageIndex !== 0) {
          setPageIndex(0);
        }
      }}
    >
      {resourceTypeFilter?.label || t("filters.byResourceType")}
    </FilterButton>
  );
};
